// store/assessmentSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AssessmentState {
  selectedIndices: number[];
  chat: { role: "user" | "assistant"; text: string }[];
}

const initialState: AssessmentState = {
  selectedIndices: [],
  chat: []
};

const assessmentSlice = createSlice({
  name: "assessment",
  initialState,
  reducers: {
    toggleSelection: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (state.selectedIndices.includes(index)) {
        state.selectedIndices = state.selectedIndices.filter(i => i !== index);
      } else {
        state.selectedIndices.push(index);
      }
    },
    addChatMessage: (state, action: PayloadAction<{ role: "user" | "assistant"; text: string }>) => {
      state.chat.push(action.payload);
    }
  }
});

export const { toggleSelection, addChatMessage } = assessmentSlice.actions;
export default assessmentSlice.reducer;
